module.exports = __webpack_public_path__ + "assets/Confetti.8259acaf.svg";